import {combineReducers} from 'redux'

import sourcesReducer from './modules/sources/reducer'
import segmentsReducer from './modules/segments/reducer'

export default combineReducers({
    sources: sourcesReducer,
    segments: segmentsReducer
})
